/** @module routes/spaces */
import React, { useEffect } from "react";
import { AnalyticsService } from "app/services";
import {
  fetchDemoSpaceAction,
  DemoSpaceModel,
  clearDemoSpace,
} from "app/actions/DemoSpace";
import { NoResults } from "app/components/Layouts";
import { Loading } from "app/components/Wrappers";
import { isAuthenticated } from "app/utils/auth";
import UserAvatar from "app/components/UserAvatar";
import no_space_png from "app/images/null-training-space.png";
import Styles from "./styles.module.scss";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "typedefs";

type PropsDef = {
  sport?: string;
};

// const HOVER_CLASS = 'hover';

/**
 * @class SpaceDemoList
 *
 */
export default function SpaceDemoList(props: PropsDef) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const demoSpace = useSelector((state: RootState) => state.demoSpace);

  useEffect(() => {
    dispatch(fetchDemoSpaceAction(null, props?.sport));

    return () => {
      dispatch(clearDemoSpace());
    };
  }, [dispatch]);

  const route = (path: string) => {
    history.push(path);
  };

  const routeToSpace = (model: DemoSpaceModel) => {
    const params: { back?: string; frame?: string } = {};
    if (!isAuthenticated()) {
      params.back = "true";
    }
    route(`/spaces/demo/${model.demoSpaceId}`);
  };

  const spaceClicked = (model: DemoSpaceModel) => {
    const trackProps = { "Demo Space Name": model.space.athleteName };
    AnalyticsService.track("Demo Space Viewed", trackProps, () =>
      routeToSpace(model),
    );
  };

  let content: JSX.Element;
  if (demoSpace.data != null && demoSpace.data.length) {
    let spaceList: JSX.Element[] = [];
    spaceList = demoSpace.data.map((demoSpace: DemoSpaceModel, key: any) => {
      return (
        <SpaceItem key={key} demoSpace={demoSpace} onClick={spaceClicked} />
      );
    });

    content = <div className={Styles.space_container}>{spaceList}</div>;
  } else {
    // const filterFunc = () => {
    //   demoSpace.fetchUpdate(undefined, null);
    // };

    content = (
      <NoResults
        image={no_space_png}
        text={t("Inspirational Spaces")}
        children={
          <Trans
            i18nKey="no_space_examples"
            components={{ strong: <strong />, click: <a href="#" /> }}
            values={{ sport: props.sport }}
          />
        }
      />
    );
  }

  return (
    <Loading className={Styles.spaceList} isLoading={demoSpace.pending}>
      {content}
    </Loading>
  );
}

type ItemPropsDef = {
  demoSpace: DemoSpaceModel;
  onClick: (model: DemoSpaceModel) => void;
};

function SpaceItem({ demoSpace, onClick }: ItemPropsDef) {
  return (
    <div className={Styles.container} onClick={() => onClick(demoSpace)}>
      <div className={Styles.box_contaienr}>
        <div className={Styles.avatar_container}>
          <UserAvatar
            srcName={demoSpace?.space?.athleteAvatar}
            altName={demoSpace?.space?.athleteName}
            userName={demoSpace?.space?.athleteName}
            className={Styles.avatar}
          />
        </div>
        <div className={Styles.title_wrapper}>
          <h4>{demoSpace.space.athleteName}</h4>
          <h6>{demoSpace.space.sport}</h6>
        </div>
      </div>
    </div>
  );
}
